import { FunctionComponent } from 'react';

import ProductStage from 'models/ProductStage';

import { groupByKey } from 'utils/array';

import HtmlStyledContent from 'components/layout/HtmlStyledContent';
import { Variants } from 'components/layout/HtmlStyledContent/types';
import LayoutContainer from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

export interface GroupedStage {
    stage: string;
    values: ProductStage[];
}

const PublicSectionProductStagesDefault: FunctionComponent<Props> = ({ stages, translations }) => {
    if (!stages) return null;

    const { headline } = translations;

    const sortedStages = stages.sort((a, b) => (a.order > b.order) ? 1 : -1);
    const groupedStages: GroupedStage[] = sortedStages?.length > 0 && (groupByKey('stage', sortedStages) || []);

    return (
        <StyledComponent className="public-section-product-stages-default">
            <LayoutContainer>
                {headline && (
                    <div
                        className="headline"
                        dangerouslySetInnerHTML={{ __html: headline }}
                    />
                )}
                <div className="grouped-stages">
                    {groupedStages.map((groupedStage, idx) => (
                        <div
                            key={groupedStage.stage}
                            className="stage-container"
                        >
                            <div className="stage-title">
                                {groupedStage.values?.[0]?.title}
                                <div className="stage-title__circle">
                                    <p className="stage-title__number">
                                        {idx + 1}
                                    </p>
                                </div>
                            </div>
                            <div className="stages">
                                {groupedStage.values.map(stage => (
                                    <HtmlStyledContent
                                        key={stage.id}
                                        variant={Variants.ProductStages}
                                        html={stage.description}
                                    />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicSectionProductStagesDefault;
